exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-d24d5b66]{font-size:20px;font-weight:bold}", ""]);

// exports
